export const CRM_CONTACT_FORM_MODULE_ID = 'crm-contact-form-module';

export const LOAD_CRM_CONTACT_FORM_MODULE = () =>
  import('@capital-access/crm/contact-form').then(m => m.CrmContactFormModule);
